import React, { useEffect, useState } from "react";
import "./Customers.css";
import {
  Container,
  Row,
  Col,
  Card,
  Modal,
  Form,
  Button,
} from "react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Sidebar from "../../components/Sidebar/Sidebar";
import "@progress/kendo-theme-default/dist/all.css";
import * as BsIcons from "react-icons/bs";
import {
  AddCustomer,
  GetCustomerShortDetail,
  UpdateCustomer,
} from "../../apis/CustomerAPI";
import { RadioButton } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GetDepartments } from "../../apis/MiscAPI";
import { GetBase64 } from "../../utils/Utility";
import { useAlert } from "react-alert";
import Loader from "../../components/Loader";

export default function () {
  const alert = useAlert();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerid = searchParams.get("id");
  const [customerName, setCustomerName] = useState("");
  const [customerId, setCustomerId] = useState(0);
  const [department, setDepartment] = useState("");
  const [subsType, setSubsType] = useState("");
  const [restriction, setRestriction] = useState("");
  const [gst, setGST] = useState("");
  const [disclaimerName, setDisclaimerName] = useState("");
  const [logo, setLogo] = useState("");
  const [departments, setDepartments] = useState([]);
  const [membershipFee, setMembershipFee] = useState(0);
  const [membershipExpiryDate, setMembershipExpiryDate] = useState("");
  const [serviceFee, setServiceFee] = useState(0);

  const [showLoader, setShowLoader] = useState(false);

  const defaultDepartment = {
    departmentName: "Choose Dept...",
    id: 0,
  };
  const [disableBtn, setDisableBtn] = useState(false);

  const [errorLists, setError] = useState([]);

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setDisableBtn(true);
    if (validate()) {
      var data = {
        id: customerId,
        totalRows: 0,
        customerName: customerName,
        subscriptionType: subsType,
        requestorCount: 0,
        departmentId: department.id,
        departmentName: "",
        gstExempt: gst,
        restriction: restriction,
        disclaimerName: disclaimerName,
        logoPath: logo,
        membershipFee: membershipFee,
        membershipExpiryDate: "",
        serviceFee: serviceFee,
      };

      if (customerId === 0) {
        setShowLoader(true);
        var result = await AddCustomer(data);
        setDisableBtn(false);
        if (result.data !== 0) {
          alert.success("Customer added", {
            onClose: () => navigate("/Admin/Customers"),
          });
        } else alert.error("Unable to add customer",{onClose: () => setShowLoader(false)});
      } else {
        setShowLoader(true);
        result = await UpdateCustomer(data);
        setDisableBtn(false);
        if (result.data) {
          alert.success("Customer updated", {
            onClose: () => navigate("/Admin/Customers"),
          });
        } else alert.error("Unable to update customer",{onClose: () => setShowLoader(false)});
      }
    } else setDisableBtn(false);
  };

  //// Validation Function
  function validate() {
    let isValid = true;
    var errorList = [];
    /// Validation for customer name
    var regCustName = /^[a-zA-Z0-9]+$/;
    if (customerName === undefined || customerName === "") {
      isValid = false;
      errorList.push("customerName");
    } // else if (!regCustName.test(customerName)) {
    //   if (!regCustName.test(customerName)) {
    //     isValid = false;
    //     errorList.push("customerName");
    //   }
    // }

    /// validation for department
    if (department === undefined || department === "") {
      isValid = false;
      errorList.push("department");
    }

    /// validation for restriction
    if (restriction === undefined || restriction === "") {
      isValid = false;
      errorList.push("restriction");
    }

    /// validation for disclaimerName
    if (disclaimerName === undefined || disclaimerName === "") {
      isValid = false;
      errorList.push("disclaimerName");
    }

    if (membershipFee === undefined || membershipFee === 0) {
      isValid = false;
      errorList.push("membershipFee");
    }

    if (serviceFee === undefined || serviceFee === 0) {
      isValid = false;
      errorList.push("serviceFee");
    }

    console.log(errorList);
    setError(errorList);
    return isValid;
  }

  function handleFileChange(event) {
    const file = event.target.files[0];
    if (
      (file.type.includes("jpeg") || file.type.includes("png")) &&
      file.size <= 1000000
    ) {
      GetBase64(file, (result) => {
        setLogo(result);
      });
    } else
      alert.error("file must be less than 1Mb and format should be jpg or png");
  }
  useEffect(() => {
    async function GetDepartmentList() {
      var result = await GetDepartments();
      //console.log(result.data);
      setDepartments(result.data);
    }
    GetDepartmentList();
  }, []);

  useEffect(() => {
    if (customerid != null && customerid !== 0) getCustomer(customerid);
  }, [departments.length]);

  async function getCustomer(id) {
    var result = await GetCustomerShortDetail(id);
    var customer = result.data;
    setCustomerId(id);
    setCustomerName(customer.customerName);
    const dept = departments.filter(
      (dept) => dept.id === customer.departmentId
    );
    if (dept.length === 0) {
      setDepartment(defaultDepartment);
    } else
      setDepartment({ departmentName: dept[0].departmentName, id: dept[0].id });
    setRestriction(customer.restriction);
    setSubsType(customer.subscriptionType);
    setGST(customer.gstExempt);
    setDisclaimerName(customer.disclaimerName);
    setLogo(customer.logoPath);
    setMembershipFee(customer.membershipFee);
    setMembershipExpiryDate(customer.membershipExpiryDate);
    setServiceFee(customer.serviceFee);
  }
  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="mt-5">
                  <Col lg={12} xs={12}>
                    <Card className="notifications-card">
                      <div className="card-head addcust-head addnew-customer">
                        <div className="card-title">
                          <h2>
                            {customerId === 0
                              ? "Add New Customer"
                              : "Edit Customer Detail"}
                              
                          </h2>
                        </div>
                        <Link to="/Admin/Customers" className="back-btn">
                          <BsIcons.BsArrowLeft />
                        </Link>
                      </div>
                      <Row className="detail-box addnew-customer-form">
                        <Form onSubmit={handleSubmit}>
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicText"
                          >
                            <Row>
                              <Col lg={5} md={12} className="rgtlbl">
                                <Form.Label className="field-required">
                                  Customer Name:
                                </Form.Label>
                              </Col>
                              <Col lg={7} md={12}>
                                <Form.Control
                                  type="text"
                                  value={customerName}
                                  onChange={(e) =>
                                    setCustomerName(e.target.value)
                                  }
                                  className={
                                    errorLists.includes("customerName")
                                      ? "is-invalid"
                                      : ""
                                  }
                                />
                              </Col>
                            </Row>
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="formBasicSelect"
                          >
                            <Row>
                              <Col lg={5} md={12} className="rgtlbl">
                                <Form.Label className="field-required">
                                  Department:
                                </Form.Label>
                              </Col>
                              <Col lg={7} md={12}>
                                <DropDownList
                                  style={{ width: "100%" }}
                                  data={departments}
                                  textField="departmentName"
                                  dataItemKey="id"
                                  defaultItem={defaultDepartment}
                                  value={department}
                                  onChange={(e) =>
                                    setDepartment(e.target.value)
                                  }
                                  className={
                                    errorLists.includes("department")
                                      ? "is-invalid"
                                      : ""
                                  }
                                />
                              </Col>
                            </Row>
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="formBasicText"
                          >
                            <Row>
                              <Col lg={5} md={12} className="rgtlbl">
                                <Form.Label className="field-required">
                                  Restrictions:
                                </Form.Label>
                              </Col>
                              <Col lg={7} md={12} className="rgtlbl">
                                <Form.Control
                                  type="text"
                                  value={restriction}
                                  onChange={(e) =>
                                    setRestriction(e.target.value)
                                  }
                                  className={
                                    errorLists.includes("restriction")
                                      ? "is-invalid"
                                      : ""
                                  }
                                />
                              </Col>
                            </Row>
                          </Form.Group>

                          <Form.Group
                            className="mb-1 preradio"
                            controlId="formBasicText"
                          >
                            <Row>
                              <Col lg={5} md={12} className="rgtlbl">
                                <Form.Label>Prepaid/Invoiced?:</Form.Label>
                              </Col>
                              <Col lg={7} md={12}>
                                <div className="prebox">
                                  <span>
                                    <RadioButton
                                      name="substype"
                                      value="Prepaid"
                                      checked={subsType === "Prepaid"}
                                      label="Prepaid"
                                      onChange={(e) => setSubsType(e.value)}
                                    />
                                  </span>
                                  <span>
                                    <RadioButton
                                      name="substype"
                                      value="Invoiced"
                                      checked={subsType === "Invoiced"}
                                      label="Invoiced"
                                      onChange={(e) => setSubsType(e.value)}
                                    />
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </Form.Group>

                          <Form.Group
                            className="mb-1 preradio"
                            controlId="formBasicText"
                          >
                            <Row>
                              <Col lg={5} md={12} className="rgtlbl">
                                <Form.Label>GST Exempt?:</Form.Label>
                              </Col>
                              <Col lg={7} md={12}>
                                <div className="prebox">
                                  <span>
                                    <RadioButton
                                      name="gst"
                                      value="Yes"
                                      checked={gst === "Yes"}
                                      label="Yes"
                                      onChange={(e) => setGST(e.value)}
                                    />
                                  </span>
                                  <span>
                                    <RadioButton
                                      name="gst"
                                      value="No"
                                      checked={gst === "No"}
                                      label="No"
                                      onChange={(e) => setGST(e.value)}
                                    />
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="formBasicText"
                          >
                            <Row>
                              <Col lg={5} md={12} className="rgtlbl">
                                <Form.Label className="field-required">
                                  Disclaimer Name for Forms:
                                </Form.Label>
                              </Col>
                              <Col lg={7} md={12}>
                                <Form.Control
                                  type="text"
                                  value={disclaimerName}
                                  onChange={(e) =>
                                    setDisclaimerName(e.target.value)
                                  }
                                  className={
                                    errorLists.includes("disclaimerName")
                                      ? "is-invalid"
                                      : ""
                                  }
                                />
                              </Col>
                            </Row>
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="formBasicText"
                          >
                            <Row>
                              <Col lg={5} md={12} className="rgtlbl">
                                <Form.Label className="field-required">
                                  Membership Fee:
                                </Form.Label>
                              </Col>
                              <Col lg={7} md={12}>
                                <Form.Control
                                  type="number"
                                  value={membershipFee}
                                  onChange={(e) =>
                                    setMembershipFee(e.target.value)
                                  }
                                  className={
                                    errorLists.includes("membershipFee")
                                      ? "is-invalid"
                                      : ""
                                  }
                                ></Form.Control>
                              </Col>
                            </Row>
                          </Form.Group>

                          <Form.Group
                            className={
                              customerid != null && customerid != 0
                                ? "mb-3"
                                : "hideDiv"
                            }
                            controlId="formBasicText"
                          >
                            <Row>
                              <Col lg={5} nd={12} className="rgtlbl">
                                <Form.Label>Membership Expiry Date:</Form.Label>
                              </Col>
                              <Col lg={7} md={12}>
                                <Form.Control
                                  type="text"
                                  value={membershipExpiryDate}
                                  readOnly={true}
                                ></Form.Control>
                              </Col>
                            </Row>
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="formBasicText"
                          >
                            <Row>
                              <Col lg={5} md={12} className="rgtlbl">
                                <Form.Label className="field-required">
                                  Service Fee:
                                </Form.Label>
                              </Col>
                              <Col lg={7} md={12}>
                                <Form.Control
                                  type="number"
                                  value={serviceFee}
                                  onChange={(e) =>
                                    setServiceFee(e.target.value)
                                  }
                                  className={
                                    errorLists.includes("serviceFee")
                                      ? "is-invalid"
                                      : ""
                                  }
                                ></Form.Control>
                              </Col>
                            </Row>
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="formBasicText"
                          >
                            <Row>
                              <Col lg={5} md={12} className="rgtlbl">
                                <Form.Label>Logo:</Form.Label>
                              </Col>
                              <Col lg={7} md={12}>
                                <Form.Control
                                  type="file"
                                  onChange={handleFileChange}
                                />
                              </Col>
                            </Row>
                          </Form.Group>

                          <Form.Group
                            className="mb-5"
                            controlId="formBasicText"
                          >
                            <Row>
                              <Col lg={5} md={12}></Col>
                              <Col lg={7} md={12}>
                                {logo == null || logo === "" ? (
                                  <div className="imgicon">
                                    <BsIcons.BsFileEarmarkImage />
                                  </div>
                                ) : (
                                  <img
                                    src={logo}
                                    alt="logo"
                                    style={{ height: 100 }}
                                  />
                                )}
                              </Col>
                            </Row>
                          </Form.Group>

                          <Row className="ordbtn">
                            <Col lg={12} md={12} className="btorng updtbtn">
                              <Button type="submit" disabled={disableBtn}>
                                {customerId === 0
                                  ? "Add Customer"
                                  : "Update Customer"}
                                  <Loader visible={showLoader} ibutton={true} />
                              </Button>
                            </Col>
                          </Row>
                        </Form>
                      </Row>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
